<template>
  <div class="dynamic-page-container">
    <template v-if="isLoading">
      <Loading />
    </template>
    <template v-else>
      <component
        :is="evaluateComponentToRender()"
        :subSectionData="subSectionData"
        :configData="configData"
      />
    </template>
  </div>
</template>

<script>
import { config_settings } from '@/config.js';
import { getSubSection } from '@/service/sections.service';
import {
  CATALOG_PAGE,
  FREE_HTML_PAGE,
  BANNER_AND_FREE_HTML_PAGE,
  BANNER_AND_FREE_HTML_PAGE_W_ITEMS,
  SERVICE_DETAIL_PAGE,
  HOME_PAGE,
  CONTACT_PAGE,
  COMPANY_INFORMATION_PAGE,
  PUBLICATIONS_PAGE,
} from '@/types/sectionTypes.constants';
import Loading from '@/views/Loading/Loading';
import About from '@/views/About';
import Comunity from '@/views/Comunity';
import ComunityRedesign from '@/views/ComunityRedesign';
import Contact from '@/views/Contact';
import Guide from '@/views/Guide';
import OurShop from '@/views/OurShop';
import PublicationsPage from '@/views/PublicationsPage';
import Home from '@/views/Home';
import '../StandartDynamicPageContainer/StandartDynamicPageContainer.scss';

export default {
  name: 'StandartDynamicPageContainer',
  props: ['idSubSection', 'configData'],
  components: {
    Loading,
    About,
    Comunity,
    ComunityRedesign,
    Contact,
    Guide,
    OurShop,
    Home,
    PublicationsPage,
  },
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      subSectionData: {},
      subSectionType: '',
      isLoading: false,
      pageTitle: '',
      pageDescription: '',
      pageKeywords: '',
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.scrollToTop();
        this.getSubSectionData();
      },
    },
  },
  metaInfo() {
    return {
      title: this.pageTitle ? this.pageTitle + ' - ' + this.configData.general.webTitle : '',
      meta: [
        { name: 'description', content: this.pageDescription ? this.pageDescription : '' },
        { name: 'keywords', content: this.pageKeywords ? this.pageKeywords : '' },
        { name: 'robots', content: 'index' },
      ],
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    getSubSectionData() {
      this.isLoading = true;
      getSubSection(this.idSubSection)
        .then((response) => {
          this.subSectionData = response.data;
          this.subSectionType = this.subSectionData.type;
          this.pageTitle = this.subSectionData.nom_sub_sec_es;
          this.pageDescription = this.subSectionData.desc_sub_section_es;
          //this.pageKeywords = this.subSectionData.keywords;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log('error: ' + error + this.idSubSection);
        });
    },

    evaluateComponentToRender() {
      let componentToRender;
      if (this.subSectionType === CATALOG_PAGE) {
        //componentToRender = About;
      } else if (this.subSectionType === FREE_HTML_PAGE) {
        //componentToRender = About;
      } else if (this.subSectionType === BANNER_AND_FREE_HTML_PAGE) {
        componentToRender = this.configData.designFlags.isRedesignBlog
          ? ComunityRedesign
          : Comunity;
      } else if (this.subSectionType === BANNER_AND_FREE_HTML_PAGE_W_ITEMS) {
        componentToRender = Guide;
      } else if (this.subSectionType === SERVICE_DETAIL_PAGE) {
        //componentToRender = About;
      } else if (this.subSectionType === HOME_PAGE) {
        componentToRender = Home;
      } else if (this.subSectionType === CONTACT_PAGE && this.idSubSection == 6) {
        componentToRender = Contact;
      } else if (this.subSectionType === CONTACT_PAGE && this.idSubSection == 4) {
        componentToRender = OurShop;
      } else if (this.subSectionType === COMPANY_INFORMATION_PAGE) {
        componentToRender = About;
      } else if (this.subSectionType === PUBLICATIONS_PAGE) {
        componentToRender = PublicationsPage;
      }
      return componentToRender;
    },
  },

  created() {
    this.scrollToTop();
    this.getSubSectionData();
  },
};
</script>
